import React from "react";
// mui 5
import Chip from "@mui/material/Chip";
// custom style
import { StyledPokemonAbilities, StyledTypogrophy } from "./styledComponents";

function PokemonAbilities({ abilities }) {
  const ability = abilities.slice(0, 1)
  return (
    <StyledPokemonAbilities>
      <StyledTypogrophy variant="body2">Ability</StyledTypogrophy>

      <Chip
        label={ability}
        size="small"
        variant="outlined"
        color="primary"

      />
    </StyledPokemonAbilities>
  );
}

export default PokemonAbilities;
